var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { getPatientPrescriptionMonitoringSummary, setPrescriptionMonitoringNoted } from '../../Async/DecisionSupportAsync';
import { Button, ButtonMode } from '../../Components/Button';
import { ImprovedDataTable } from '../../Components/DataTable/ImprovedDataTable';
import { useError } from '../../Components/ErrorBoundary';
import { FullScreenModalButtonContainer, FullScreenModalInfo, FullScreenModalTitle } from '../../Components/FullScreenModal';
import { EditIcon, ExternalLinkIcon, StyledMedicationDecisionSupportAlertIcon, StyledMedicationDecisionSupportWarningIcon } from '../../Components/Icons';
import { MedicationCard, MedicationCardMode } from '../../Components/MedicationCard';
import { LoadingPlaceholder } from '../../Components/Placeholder';
import { useMedicationSettings } from '../../Config/MedicationConfig';
import { PrescriptionMonitoringStatus } from '../../Contracts/MedicationModels';
import { CancelledRequest, useHttpConfig } from '../../Shared/HttpRequestExecutor';
import { dangerVariant, iconLight, warningGlowBorder } from '../../Styles/Colours';
import styles from './PrescriptionMonitoringStep.module.css';
var DisplayPatientMedication = function (row) {
    var patientMedication = row.patientMedication;
    var strength = Number(patientMedication.strength);
    return (React.createElement("div", { className: styles.medicationCard },
        React.createElement(MedicationCard, { name: patientMedication.name, strength: isNaN(strength) ? 0 : strength, strengthUnit: patientMedication.strengthUnits, type: patientMedication.type, size: patientMedication.packAmount, productPackAmount: patientMedication.productPackAmount, repeatsAmount: patientMedication.repeatsAmount, mode: MedicationCardMode.Long, isNonStandardPackSize: patientMedication.isNonStandardPackSize, nonStandardPackSize: patientMedication.nonStandardPackSize })));
};
var getColumns = function (props) {
    var DisplayActions = function (row) {
        var firstResponse = row.responses.filter(function (it) { return !!it.contextualLinkUrl; })[0];
        return (React.createElement("div", { className: styles.actionButtons },
            React.createElement(Button, { iconOnly: true, tooltip: 'Edit', mode: ButtonMode.text, noShadowOnHover: true, testId: "navigation-edit-" + row.patientMedication.id, subtleShadeOnHover: true, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onNavigateToMedication(row.patientMedication.id);
                } },
                React.createElement(EditIcon, { color: iconLight, size: '24' })),
            firstResponse && (React.createElement(Button, { iconOnly: true, tooltip: 'Open in new window', mode: ButtonMode.text, noShadowOnHover: true, testId: "navigation-open-new-window-" + row.patientMedication.id, subtleShadeOnHover: true, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (firstResponse)
                        window.open(firstResponse.contextualLinkUrl, '_blank');
                } },
                React.createElement(ExternalLinkIcon, { color: iconLight, size: '24' })))));
    };
    return [
        {
            name: 'patientMedication',
            title: 'Medication name',
            getCellValue: DisplayPatientMedication
        },
        {
            name: 'responseDescription',
            title: 'Alert',
            getCellValue: function (row) {
                var _a;
                if (row.responses.length > 0) {
                    var alert_1 = row.status === PrescriptionMonitoringStatus.Alert ||
                        row.status === PrescriptionMonitoringStatus.Error;
                    var warning = row.status === PrescriptionMonitoringStatus.Warning;
                    var icon = alert_1 ? (React.createElement("span", { className: styles.icon },
                        React.createElement(StyledMedicationDecisionSupportAlertIcon, { color: dangerVariant }))) : warning ? (React.createElement("span", { className: styles.icon },
                        React.createElement(StyledMedicationDecisionSupportWarningIcon, { color: warningGlowBorder }))) : null;
                    var responseText = void 0;
                    if (row.responses.length === 1) {
                        responseText = row.responses[0].responseDescription;
                    }
                    else {
                        responseText = (React.createElement("div", { className: styles.content },
                            "We found the following alerts below:",
                            React.createElement("ul", null, row.responses.map(function (response, index) {
                                return React.createElement("li", { key: index }, response.responseDescription);
                            }))));
                    }
                    return (React.createElement("div", { className: classNames(styles.response, (_a = {},
                            _a[styles.alertDescription] = alert_1,
                            _a[styles.warningDescription] = warning,
                            _a)) },
                        icon,
                        responseText));
                }
                return '';
            }
        },
        {
            name: 'status',
            title: 'Action',
            getCellValue: DisplayActions
        }
    ];
};
var ROW_HEIGHT = 72;
var columnExtensions = [
    {
        columnName: 'patientMedication'
    },
    {
        columnName: 'responseDescription',
        width: 450
    },
    {
        columnName: 'status',
        width: 120
    }
];
export var PrescriptionMonitoringStep = function (props) {
    var throwError = useError();
    var httpConfig = useHttpConfig();
    var _a = __read(useState(null), 2), summary = _a[0], setSummary = _a[1];
    var _b = __read(useState(false), 2), noting = _b[0], setNoting = _b[1];
    var medSettings = useMedicationSettings();
    var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var query, data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    query = {
                        patientMedication: props.patientMedication,
                        showSkippedForNotChecked: !!props.patientMedication || props.state.skipped
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getPatientPrescriptionMonitoringSummary(httpConfig, props.patient, query)];
                case 2:
                    data = _a.sent();
                    if (data instanceof CancelledRequest)
                        return [2 /*return*/];
                    setSummary(data);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    throwError(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (medSettings.settings.decisionSupportSettings.prescriptionMonitoringEnabled)
            loadData();
        else
            props.onContinue();
    }, []);
    var handleNotedClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var medications, result, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!summary)
                        return [2 /*return*/];
                    setNoting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    medications = {
                        skipNotChecked: props.state.skipped,
                        patientMedications: summary.map(function (it) { return it.patientMedication; })
                    };
                    return [4 /*yield*/, setPrescriptionMonitoringNoted(props.patient, medications)];
                case 2:
                    result = _a.sent();
                    if (result) {
                        props.onContinue();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    throwError(err_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleContinueClick = function () {
        props.onContinue();
    };
    if (summary == null)
        return (React.createElement("div", { className: styles.centerWithinModal },
            React.createElement(LoadingPlaceholder, null)));
    return (React.createElement("div", { className: styles.container },
        React.createElement(FullScreenModalTitle, { title: 'Prescription monitoring' }),
        React.createElement(FullScreenModalInfo, { info: 'Please review and note the prescription monitoring alert found.' }),
        React.createElement("div", { className: styles.alertsTable },
            React.createElement(ImprovedDataTable, { columns: getColumns(props), rowHeight: ROW_HEIGHT, data: summary, getRowId: function (item) { return item.patientMedication.id; }, columnExtensions: columnExtensions, cellStyles: function () { return styles.cells; } })),
        React.createElement(FullScreenModalButtonContainer, null, props.readOnly ? (React.createElement(Button, { key: 'continue', width: 168, type: 'button', testId: 'navigation-control-continue', onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                handleContinueClick();
            } }, "Continue")) : (React.createElement(Button, { key: 'noted', width: 168, type: 'button', disabled: noting, testId: 'navigation-control-noted', onClick: function (e) {
                e.preventDefault();
                e.stopPropagation();
                handleNotedClick();
            } }, "Noted")))));
};
